import { useMemo, useEffect } from "react";
import { debounce } from "lodash";

export function useDebouncedCallback(callback, delay, canvas) {
  // Memoize the debounced function
  const debouncedCallback = useMemo(
    () => debounce(callback, delay),
    [callback, delay]
  );

  // Cleanup on unmount or when dependencies change
  useEffect(() => {
    return () => {
      debouncedCallback.cancel();
    };
  }, [debouncedCallback]);

  return debouncedCallback;
}
